// extracted by mini-css-extract-plugin
module.exports = {"editor":"Wysiwyg_editor__3cuWB"};